import { Box, Container, Paper, Typography } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cleanMessagingAccidents, getConversationModel } from "../../../actions/messaging";
import NewConversationForm from "./newConversationForm";

const NewConversationContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedProvider = useSelector((state) => state.providers.selectedProvider);

  useEffect(() => {
    if (selectedProvider) {
      dispatch(getConversationModel(null, selectedProvider));
    }

    return () => {
      dispatch(cleanMessagingAccidents());
    };
  }, [dispatch, selectedProvider]);

  const handleSuccess = () => {
    navigate("/messaging/waiting", { state: { skipUnsavedGuard: true } });
  };

  const handleClose = () => {
    navigate("/messaging/pending");
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold" }}>
          Nueva Conversación
        </Typography>

        <Box>
          <NewConversationForm onSuccess={handleSuccess} handleClose={handleClose} />
        </Box>
      </Paper>
    </Container>
  );
};

export default NewConversationContainer;
